import { useContext } from 'react';
import { authContext } from '../context';

export const useAuth = () => {
  const context = useContext(authContext);
  if (!context) throw new Error('There is no auth provider');
  return context;
};
